import { Getter, GetterTree } from "vuex";
import { RootState } from "@/store/RootState";
import { HomePageGetter, HomePageState } from "@/components/homePage/types";

export const getters: GetterTree<HomePageState, RootState> &
  Record<HomePageGetter, Getter<HomePageState, RootState>> = {
  [HomePageGetter.GetPlayedChannelIndex](state) {
    return state.playedChannelIndex;
  },
  [HomePageGetter.GetWidgetKeyControl](state) {
    return state.widgetKeyControl;
  },
  [HomePageGetter.GetActiveSlideIndexMap](state) {
    return state.activeSlideIndexMap;
  },
  [HomePageGetter.GetPlayedWidgetIndex](state) {
    return state.playedWidgetIndex;
  },
  [HomePageGetter.GetPromotionKeyControl](state) {
    return state.promotionKeyControl;
  }
};
